module.exports = __webpack_public_path__ + "static/media/in.131e7862.svg";